import { MouseEvent } from 'react';

import { Box } from '@mui/material';

import { useClientStorageFlag } from '@/entities/clientStorage';
import { useCurrentUser } from '@/entities/user/currentUser';

import giftImage from '@/shared/assets/images/gift.png';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { PromoBanner } from '@/shared/ui/PromoBanner';

import { useRecordingFeedbackBonusModalStore } from '../../model/useRecordingFeedbackBonusModalStore';

// Backend-stored dismissal: clientStorage is authenticated and scoped per-user, so the
// flag does not leak across users on a shared device and survives across browsers/sessions.
const STORAGE_KEY = 'recordingFeedbackBonusBannerDismissed';

const GiftIcon = () => (
  <Box
    alt=""
    component="img"
    src={giftImage}
    sx={{ display: 'block', height: 32, objectFit: 'contain', width: 32 }}
  />
);

export const RecordingFeedbackBonusBanner = () => {
  const { data: user } = useCurrentUser();
  const open = useRecordingFeedbackBonusModalStore((state) => state.open);

  const { hasShown: dismissed, isLoading, markAsShown } = useClientStorageFlag(STORAGE_KEY, { enabled: Boolean(user) });

  const isClaimed = Boolean(user?.recording_feedback_bonus_claimed);
  const isShown = Boolean(user) && !isLoading && !isClaimed && !dismissed && !IS_WHITE_LABEL;

  if (!isShown) return null;

  const handleOpen = (event: MouseEvent) => {
    event.preventDefault();
    open();
  };

  return (
    <PromoBanner
      title="Get free minutes!"
      icon={<GiftIcon />}
      link={{ children: 'Grab free 5 minutes', to: '#', onClick: handleOpen }}
      variant="primary"
      onClose={markAsShown}
    />
  );
};
